var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReminderFeedbackImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 565.5,
    height: 381.5,
    viewBox: "0 0 565.5 381.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:#fff;}.cls-1{stroke:#7f7f7f;stroke-miterlimit:10;stroke-width:4px;}.cls-2{fill:#fbccc3;}.cls-3{fill:#7f7f7f;}.cls-5{fill:#23ca47;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 77,
    y: 108.5,
    width: 417,
    height: 236,
    rx: 30.7155
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 32,
    y: 362.5,
    width: 507,
    height: 17,
    rx: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 228,
    y: 221.5,
    width: 115,
    height: 10,
    rx: 5,
    transform: "translate(-76.5387 268.2193) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 234.4124,
    y: 204,
    width: 67.1752,
    height: 10,
    rx: 5,
    transform: "translate(-69.2899 250.7193) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 268.9124,
    y: 238.5,
    width: 67.1752,
    height: 10,
    rx: 5,
    transform: "translate(-83.5803 285.2193) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 3.5,
    width: 149,
    height: 282,
    rx: 30.7155
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2,
    y1: 43.5,
    x2: 151,
    y2: 43.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 2,
    y1: 246.5,
    x2: 151,
    y2: 246.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 53.5,
    y: 19,
    width: 26,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 85.5,
    y: 19,
    width: 16,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 77,
    cy: 265.5,
    r: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 3.7367,
    y: 73.8843,
    width: 57.2757,
    height: 4.9805,
    rx: 2.4902,
    transform: "translate(-44.5227 45.2618) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 6.9304,
    y: 65.1684,
    width: 33.4565,
    height: 4.9805,
    rx: 2.4902,
    transform: "translate(-40.9124 36.546) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 24.1131,
    y: 82.3511,
    width: 33.4565,
    height: 4.9805,
    rx: 2.4902,
    transform: "translate(-48.0297 53.7286) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 487.5,
    cy: 78,
    r: 78
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M487.5.3067a78,78,0,1,0,78,78A77.8955,77.8955,0,0,0,487.5.3067Zm46.6267,52L484.0333,114.88a8.3685,8.3685,0,0,1-6.0666,3.12h-.52a8.2543,8.2543,0,0,1-5.8934-2.4267L441.5667,86.1067a8.457,8.457,0,1,1,11.96-11.96l23.2266,22.88,44.2-55.2934a8.538,8.538,0,0,1,11.96-1.3866A8.6772,8.6772,0,0,1,534.1267,52.3067Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReminderFeedbackImage);
export default __webpack_public_path__ + "static/media/reminder-feedback-image.3f34665edd8062af45817a686feea675.svg";
export { ForwardRef as ReactComponent };